export interface BusinessHours {
  monday: string; // 08:00 - 17:00 (24 time) OR "N/A"
  tuesday: string;
  wednesday: string;
  thursday: string;
  friday: string;
  saturday: string;
  sunday: string;
}

export const exampleBusinessHours: BusinessHours = {
  monday: '08:00 - 17:00',
  tuesday: '08:00 - 17:00',
  wednesday: '08:00 - 17:00',
  thursday: '08:00 - 17:00',
  friday: '08:00 - 17:00',
  saturday: 'Closed',
  sunday: 'Closed',
};
